// extracted by mini-css-extract-plugin
module.exports = {"flex":"home_flex__1tGxl","linkButton":"home_linkButton__1QRgH"};